var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.5862L16.2432 6.34323C16.6337 5.95277 17.2668 5.95277 17.6572 6.34323C18.0477 6.7337 18.0477 7.36677 17.6572 7.75723L13.4142 12.0002L17.6572 16.2432C18.0477 16.6337 18.0477 17.2668 17.6572 17.6572C17.2668 18.0477 16.6337 18.0477 16.2432 17.6572L12.0002 13.4142L7.75723 17.6572C7.36677 18.0477 6.7337 18.0477 6.34323 17.6572C5.95276 17.2668 5.95276 16.6337 6.34323 16.2432L10.5862 12.0002L6.34323 7.75723C5.95277 7.36677 5.95276 6.7337 6.34323 6.34323C6.7337 5.95277 7.36677 5.95277 7.75723 6.34323L12.0002 10.5862Z",
    fill: "#425466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fdd6820a51c2abb8e1c8922da79bd1b3.svg";
export { ForwardRef as ReactComponent };